import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-webpack-spinner";

import Modal from "./Modal";

const ModalLoading = props => {
  const { isActive, text } = props;
  return (
    <Modal isActive={isActive}>
      <div className="tag is-info is-large is-clipped">
        <Spinner width={32} height={32} color="#fff" />
        {!!text && <span style={{ marginLeft: 8 }}>{text}</span>}
        <br />
      </div>
    </Modal>
  );
};

ModalLoading.propTypes = {
  isActive: PropTypes.bool,
  text: PropTypes.string
};

ModalLoading.defaultProps = {
  text: ""
};

export default ModalLoading;



/** WEBPACK FOOTER **
 ** ./src/components/ModalLoading.jsx
 **/